// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import UserFormController from "./user_form_controller"
application.register("user-form", UserFormController)

import VacanChartController from "./vacan_chart_controller"
application.register("vacan-chart", VacanChartController)

import VisitorCountChartController from "./visitor_count_chart_controller"
application.register("visitor-count-chart", VisitorCountChartController)
